import { Box, Typography } from "../../../../Components";
import { Form } from "react-bootstrap";

const PrevMedication = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  const options = [
    {
      id: 1,
      label: "No",
    },
    {
      id: 2,
      label: "Yes",
    },
  ];
  return (
    <div>
      {" "}
      <Typography fontSize="1rem" fontWeight="400" color="#9370DB">
        MEDICAL HISTORY
      </Typography>
      <Typography fontSize="1.25rem" fontWeight="500" className="my-3">
        Previously Taken Medications (Last 6 Months)
      </Typography>
      {options?.map((option, idx) => (
        <>
          <Box
            className="p-3 my-3 cursor-pointer option-wrapper"
            onClick={() => {
              setFieldValue("previousMedication", option?.id);
            }}
            height="100%"
            width="100%"
            borderRadius="0.5rem"
            background={values?.previousMedication === option?.id && "#9370DB"}
            border={
              values?.previousMedication === option?.id && "1px solid #9370DB"
            }
          >
            <Typography
              fontSize=".9rem"
              fontWeight={values?.previousMedication === option?.id && "500"}
              className="heading"
              color={values?.previousMedication === option?.id && "white"}
            >
              {option?.label}
            </Typography>
          </Box>
          {values?.previousMedication === 2 && option?.id === 2 && (
            <>
              <Form.Control
                type="text"
                backgroundColor="#EBEBFF"
                name="previousMedicationInput"
                placeholder={
                  " e.g., mother with diabetes, father had heart disease, sibling with asthma"
                }
                className="w-100 fs-6"
                value={values?.previousMedicationInput}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={
                  touched.previousMedicationInput &&
                  !!errors.previousMedicationInput
                }
                size="lg"
                autoFocus
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.previousMedicationInput}
              </Form.Control.Feedback>
            </>
          )}
        </>
      ))}
    </div>
  );
};

export default PrevMedication;
